










import {Component, Vue} from 'vue-property-decorator';

@Component
export default class App extends Vue {

  onServiceAgreeYn(serviceAgreeYn) {
    const component: any = (this.$refs[`Component`] as any);

    if(!!component && component.onServiceAgreeYn) {
      (this.$refs[`Component`] as any).onServiceAgreeYn(serviceAgreeYn);
    }
  }

  onPersonalInfomationAgreeYn(personalInfomationAgreeYn) {
    const component: any = (this.$refs[`Component`] as any);

    if(!!component && component.onPersonalInfomationAgreeYn) {
      (this.$refs[`Component`] as any).onPersonalInfomationAgreeYn(personalInfomationAgreeYn);
    }
  }

  onMaketingAgreeYn(maketingAgreeYn) {
    const component: any = (this.$refs[`Component`] as any);

    if(!!component && component.onMaketingAgreeYn) {
      (this.$refs[`Component`] as any).onMaketingAgreeYn(maketingAgreeYn);
    }
  }
}
